'use strict';

class EventCustomFields {
  constructor($location, $window, $routeParams, eventService, customFieldService, commonService, Notification) {
    this.$location = $location;
    this.$window = $window;
    this.eventService = eventService;
    this.customFieldService = customFieldService;
    this.commonService = commonService;
    this.Notification = Notification;

    this.eventNumber = $routeParams.number;
    this.fieldNumber = $routeParams.fieldNumber;
  }

  $onInit() {
    this.field = {
      name: null,
      element: 'input',
      type: 'TEXT',
      options: null,
      required: false,
      price: {
        taxRate: 25
      }
    };

    this.priceTag = false;

    if (this.fieldNumber) {
      this.load();
    }

    this.event = angular.fromJson(this.$window.sessionStorage.getItem('event'));
  }

  load() {
    this.eventService.loadCustomField(this.eventNumber, this.fieldNumber)
      .then((resp) => {
        this.field = resp.data;

        if (this.field.price) {
          this.priceTag = true;
        }

        if (this.field.options) {
          if (this.field.options[0].price) {
            this.priceTag = true;
          }
        }
      })
      .catch((err) => {
        this.Notification.error(err.data.endUserMessage);

        if (err.status === 404) {
          this.$location.path(`/vert/${this.eventNumber}`);
        }
      });
  }

  addOption() {
    let obj = {};

    if (!$.isArray(this.field.options)) {
      this.field.options = [];
    }

    if (this.priceTag) {
      obj = {
        number: this.field.options.length + 1,
        value: null,
        price: {
          price: null,
          taxRate: 25,
          productCode: null
        }
      };
    } else {
      obj = {
        number: this.field.options.length + 1,
        value: null
      };
    }

    this.field.options.push(obj);
  }

  removeOption(number) {
    if (number) {
      // reindex
      this.field.options.forEach((option) => {
        if (option.number > number) {
          option.number = option.number - 1;
        }
      });

      this.field.options.splice(number - 1, 1);

      if (!this.field.options.length) {
        this.field.options = null;
      }
    }
  }

  success(current, clone) {
    this.event.customFields = [...current, ...[clone]];
    this.$window.sessionStorage.setItem('event', angular.toJson(this.event));

    this.$location.path(`/vert/${this.eventNumber}`);
  }

  save() {
    let current = this.event && this.event.customFields ? this.event.customFields : [];
    let clone = angular.copy(this.field);

    if (this.field.type === 'ENUM') {
      if (!this.priceTag) {
        clone.options.map((o) => {
          o.price = null;
          return o;
        });
      }

      clone.type = 'TEXT';
      clone.price = null;
    }

    if (this.field.type !== 'ENUM') {
      if (!this.priceTag) {
        clone.price = null;
      }
    }

    clone.element = null;

    if (this.customFieldService.isDuplicate(current, clone.field)) {
      if (!isNaN(this.eventNumber) && this.fieldNumber) {
        // update
        this.eventService.updateCustomField(this.eventNumber, this.fieldNumber, clone)
          .then(() => this.success(current, clone))
          .catch((err) => this.Notification.error(err.data.endUserMessage));
      } else if (!isNaN(this.eventNumber) && !this.fieldNumber) {
        // save
        this.eventService.saveCustomField(this.eventNumber, clone)
          .then(() => this.success(current, clone))
          .catch((err) => this.Notification.error(err.data.endUserMessage));
      } else {
        // save in storage
        this.success(current, clone);
      }
    } else {
      this.Notification.error(`Det finnes allerede et felt som heter <b>${clone.name}</b>, egendefinerte felter kan ikke ha samme navn.`);
    }
  }
}

EventCustomFields.$inject = ['$location', '$window', '$routeParams', 'eventService', 'customFieldService', 'commonService', 'Notification'];

const eventCustomFields = {
  bindings: {
    rates: '<'
  },
  controller: EventCustomFields,
  templateUrl: 'event/custom-field.html'
};

angular
  .module('SendRegning')
  .component('eventCustomFields', eventCustomFields)
  .config(($routeProvider) => {
    $routeProvider
      .when('/vert/:number/egendefinert-felter', {
        title: 'Egendefinert felter',
        template: '<event-custom-fields rates="$resolve.rates" />',
        secure: true,
        resolve: {
          rates: (commonService) => commonService.getConstants().then((resp) => resp.taxRates)
        }
      })
      .when('/vert/:number/egendefinert-felter/:fieldNumber', {
        title: 'Egendefinert felter',
        template: '<event-custom-fields rates="$resolve.rates" />',
        secure: true,
        resolve: {
          rates: (commonService) => commonService.getConstants().then((resp) => resp.taxRates)
        }
      });
  });
